import { deleteUser } from "@/api/users";
import { AppDispatch } from "@/app/store";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { removeUser } from "@/features/users/userSlice";
import { toast } from "@/hooks/use-toast";
import { User } from "@/models/user.model";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  user: User;
}
export function DeleteUserDialog({ isOpen, setIsOpen, user }: Props) {
  const dispatch: AppDispatch = useDispatch();

  const handleDelete = async () => {
    try {
      const res = await dispatch(removeUser(user.id));
      if (res) {
        toast({
          title: "User deleted",
          description: `User ${user.fullName} has been deleted`,
        });
        // navigate("/admin/users");
        setIsOpen(false);
      }
    } catch (err: any) {
      console.log(err);
      toast({
        title: "Error",
        description: "Failed to delete user",
        variant: "destructive",
      });
    }
  };
  return (
    <AlertDialog open={isOpen} onOpenChange={(isOpen) => setIsOpen(isOpen!)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete this
            user's account and remove his/her data from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete}>Continue</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
